import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d9f2fae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schemeContainer mt-3" }
const _hoisted_2 = {
  ref: "canvasWrapper",
  class: "canvasWrapper"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"controlInfo\" data-v-3d9f2fae><div class=\"controlInfoColumn action\" data-v-3d9f2fae><div data-v-3d9f2fae>Левая кнопка</div><div data-v-3d9f2fae>Esc</div><div data-v-3d9f2fae>Колесико мыши</div><div data-v-3d9f2fae>Левая кнопка</div><div data-v-3d9f2fae>Кнопка R</div></div><div class=\"controlInfoColumn result\" data-v-3d9f2fae><div data-v-3d9f2fae>выбрать груз / переместить груз</div><div data-v-3d9f2fae>отпустить груз</div><div data-v-3d9f2fae>приблизить / отдалить</div><div data-v-3d9f2fae>вращать камеру</div><div data-v-3d9f2fae>повернуть груз</div></div></div>", 1)
const _hoisted_4 = { ref: "canvas" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = {
  key: 0,
  class: "infoCard"
}
const _hoisted_7 = { class: "cargoTitle" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Выбранный груз ")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "infoCard transportCard" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Транспорт", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "comment" }, " X - длина, Y - высота, Z - ширина ", -1))
const _hoisted_15 = { class: "infoCard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("canvas", _hoisted_4, null, 512)
    ], 512),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.selectedCargo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, [
              _createElementVNode("div", {
                class: "cargoColor",
                style: _normalizeStyle({ background: _ctx.selectedCargo.userData.color })
              }, null, 4),
              _hoisted_8
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.selectedCargo.userData.name), 1),
              _createElementVNode("p", null, "Тип: " + _toDisplayString(_ctx.selectedCargo.userData.type === "box" ? "Коробка" : "Рулон"), 1),
              (_ctx.selectedCargo.userData.type === 'box')
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Размеры: " + _toDisplayString(_ctx.selectedCargo.userData.width) + "×" + _toDisplayString(_ctx.selectedCargo.userData.height) + "×" + _toDisplayString(_ctx.selectedCargo.userData.depth) + " см ", 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _createTextVNode(" Диаметр: " + _toDisplayString(_ctx.selectedCargo.userData.diameter) + " см", 1),
                    _hoisted_11,
                    _createTextVNode(" Высота: " + _toDisplayString(_ctx.selectedCargo.userData.height) + " см ", 1)
                  ]))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("p", null, "Размеры: " + _toDisplayString(_ctx.container.length) + "×" + _toDisplayString(_ctx.container.height) + "×" + _toDisplayString(_ctx.container.width) + " см", 1),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", null, "Грузов в сцене: " + _toDisplayString(_ctx.cargos3DCount), 1),
        _createElementVNode("p", null, "Выбран: " + _toDisplayString(_ctx.selectedCargo ? (_ctx.selectedCargo.userData.type === "box" ? "коробка" : "рулон") : '-'), 1)
      ])
    ])
  ]))
}